import { render, staticRenderFns } from "./mbPrint.vue?vue&type=template&id=ec6363f8&scoped=true"
import script from "./mbPrint.vue?vue&type=script&lang=js"
export * from "./mbPrint.vue?vue&type=script&lang=js"
import style0 from "./mbPrint.vue?vue&type=style&index=0&id=ec6363f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6363f8",
  null
  
)

export default component.exports